import React from "react";
import { useAuth } from "react-oidc-context";

import {
  Avatar,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Link,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { Button } from "react-admin";

import { CancelIcon, ImportIcon, RoadmapIcon } from "./iconography";
import { APP_VERSION } from "../../utils/constants.js";
import { isTWA, refreshApp } from "../../utils/appUtils.js";
import {
  buildRoadmapUrl,
  ensureProduktlyToken,
} from "../../utils/produktlyUtils.js";

const useStyles = makeStyles((theme) => ({
  avatar: {
    color: theme.palette.getContrastText(theme.palette.primary.main),
    backgroundColor: theme.palette.primary.main,
    width: theme.spacing(6),
    height: theme.spacing(6),
  },
  roadmapIcon: {
    marginRight: theme.spacing(1),
    color: theme.palette.text.primary,
  },
}));

export const AppInfoDialog = ({ isOpen, onClose, ...props }) => {
  const classes = useStyles();
  const auth = useAuth();

  const handleUpdate = (event) => {
    event.preventDefault();
    refreshApp();
  };

  const handleRoadmapClick = async (event) => {
    event.preventDefault();
    try {
      const produktlyToken = await ensureProduktlyToken(
        auth.user?.access_token,
      );
      window.open(
        buildRoadmapUrl(produktlyToken),
        "_blank",
        "noopener,noreferrer",
      );
    } catch (error) {
      console.error("Roadmap launch failed from App Info dialog", error);
      window.open(buildRoadmapUrl(), "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Grid container spacing={1}>
          <Grid item xs={1}>
            <Avatar className={classes.avatar}>
              <Typography variant="h4">i</Typography>
            </Avatar>
          </Grid>
          <Grid item xs={11}>
            <Box ml={3} mt={1}>
              <Typography variant="h5">About transloads.co</Typography>
            </Box>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Grid container direction="row" spacing={0}>
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="overline" color="textPrimary">
                <strong>version: {APP_VERSION}</strong>
              </Typography>
              <Box display="inline-flex" alignItems="center">
                <RoadmapIcon fontSize="small" className={classes.roadmapIcon} />
                <Link
                  href={buildRoadmapUrl()}
                  target="_blank"
                  rel="noreferrer"
                  underline="hover"
                  onClick={handleRoadmapClick}
                >
                  ROADMAP
                </Link>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="overline" color="textPrimary">
              Policies:
            </Typography>
            <ul>
              <li>
                <Link
                  href="https://transloads.co/terms-of-service/"
                  target="_blank"
                  rel="noreferrer"
                  underline="hover"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  href="https://transloads.co/privacy-policy"
                  target="_blank"
                  rel="noreferrer"
                  underline="hover"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  href="https://transloads.co/acceptable-use-policy/"
                  target="_blank"
                  rel="noreferrer"
                  underline="hover"
                >
                  Acceptable Use Policy
                </Link>
              </li>
              <li>
                <Link
                  href="https://transloads.co/service-level-agreement/"
                  target="_blank"
                  rel="noreferrer"
                  underline="hover"
                >
                  Service Level Agreement
                </Link>
              </li>
              {!isTWA() && (
                <li>
                  <Link
                    href="https://transloads.co/pricing-policy/"
                    target="_blank"
                    rel="noreferrer"
                    underline="hover"
                  >
                    Fees and Pricing Policy
                  </Link>
                </li>
              )}
            </ul>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="overline" color="textPrimary">
              &copy; Copyright 2021
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button label="Close" onClick={onClose} color="default">
          <CancelIcon />
        </Button>
        <Button label="Update" color="primary" onClick={handleUpdate}>
          <ImportIcon />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
